import { resolveGeneral } from './resolve-general';
import { resolveStore } from './resolve-store';
import { resolveAuth } from './resolve-auth';
import { resolveEmailVerification } from './resolve-email-verification';
import { resolveConfirmPrivacy } from './resolve-confirm-privacy';
import { resolveAccreditation } from './resolve-accreditation';
// import { resolveKYC } from './resolve-kyc';
import { resolveRequiresComponents } from './resolve-requires-components';
import { resolveStoreModules } from './resolve-store-modules';
import { resolveRouteDependencies } from './resolve-route-dependencies';

export async function resolvePageDependencies(to, from, next) {
  try {
    const generalPromises = await resolveGeneral(to, from);
    await resolveAuth(to, from, next);
    await resolveEmailVerification(to, from, next);
    await resolveConfirmPrivacy(to, from, next);
    await resolveAccreditation(to, from, next);
    // No pages with request to pass KYC
    // await resolveKYC(to, from, next);
    await resolveStoreModules(to);
    await resolveStore(to, from, next);
    await resolveRouteDependencies(to, from, next);
    const componentPromises = resolveRequiresComponents(to);
    await Promise.all(generalPromises.concat(componentPromises))
      .catch(() => { /* ignore errors */ });
    next();
  } catch (e) {
    // Cancel transition
    // next(new Error('cancel')); it can show page with empty content if initial page is not allowed
    // eslint-disable-next-line no-console
    console.log(e);
  }
}
